import ENTES_FISCALIZADORES from '@/graphql/querys/administracion/catalogos/entesfiscalizadores/entesFiscalizadores.gql';
import ACTUALIZAR_ENTE_FISCALIZADOR from '@/graphql/mutations/administracion/catalogos/entesfiscalizadores/actualizarEnteFiscalizador.gql';
import REMOVER_ENTE_FISCALIZADOR from '@/graphql/mutations/administracion/catalogos/entesfiscalizadores/removerEnteFiscalizador.gql';
import AGREGAR_ENTE_FISCALIZADOR from '@/graphql/mutations/administracion/catalogos/entesfiscalizadores/agregarEnteFiscalizador.gql';

export default {
  methods: {
    async mixAgregarEnteFiscalizador() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_ENTE_FISCALIZADOR,
        variables: {
          enteFiscalizador: this.enteFiscalizador,
        },
        update: (store, { data: { agregarCatalogoEnteFiscalizador } }) => {
          const data = store.readQuery({ query: ENTES_FISCALIZADORES });
          data.entesFiscalizadores.push(agregarCatalogoEnteFiscalizador);
          store.writeQuery({ query: ENTES_FISCALIZADORES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarEnteFiscalizador() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_ENTE_FISCALIZADOR,
        variables: {
          id: this.enteFiscalizadorEditar.id,
          enteFiscalizador: this.enteFiscalizador,
        },
        update: (store, { data: { actualizarCatalogoEnteFiscalizador } }) => {
          const data = store.readQuery({ query: ENTES_FISCALIZADORES });
          const { entesFiscalizadores } = data;
          const index = entesFiscalizadores
            .findIndex((ente) => ente.id === actualizarCatalogoEnteFiscalizador.id);
          if (index !== -1) {
            entesFiscalizadores.splice(index, 1, actualizarCatalogoEnteFiscalizador);
          }
          store.writeQuery({ query: ENTES_FISCALIZADORES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarEnteFiscalizador() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_ENTE_FISCALIZADOR,
        variables: {
          id: this.enteFiscalizadorEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: ENTES_FISCALIZADORES });
          const { entesFiscalizadores } = data;
          const index = entesFiscalizadores
            .findIndex((ente) => ente.id === this.enteFiscalizadorEliminar.id);
          if (index !== -1) {
            entesFiscalizadores.splice(index, 1);
          }
          store.writeQuery({ query: ENTES_FISCALIZADORES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
